import { defineNuxtPlugin } from '#app/nuxt'
import { LazySbArticleCardBig, LazySbArticleCardSmall, LazySbArticleCard, LazySbArticleContent, LazySbArticleFeedLite, LazySbArticleFeed, LazySbArticleGallery, LazySbArticleNav, LazySbArticleNew, LazySbArticleRecommendations, LazySbArticleRecommended, LazySbArticle, LazySbArticlesFeedPages, LazySbArticlesLander, LazySbArticlesPinned, LazySbArticles, LazySbBackground, LazySbBrandCardBig, LazySbBrandCard, LazySbBrand, LazySbBrandsGridBrand, LazySbBrandsGrid, LazySbBrandsLander, LazySbBrandsListingBig, LazySbBrandsListing, LazySbCampaignSlide, LazySbCampaignSlides, LazySbCatalog, LazySbCategoriesLander, LazySbCategoriesListingBig, LazySbCategoriesListing, LazySbCategoryCardBig, LazySbCategoryCard, LazySbCategoryCta, LazySbCategoryLander, LazySbCategoryMenu, LazySbClubLander, LazySbContentButton, LazySbContentForm, LazySbContentImage, LazySbCtaBig, LazySbCtaButton, LazySbCtaCampaignHeroBox, LazySbCtaCampaignHero, LazySbCtaContent, LazySbCtaCountdown, LazySbCtaDiscount, LazySbCtaImage, LazySbCtaNarrow, LazySbCtaSimpleWithDiscount, LazySbCta, LazySbCustomerServiceContent, LazySbCustomerServiceInner, LazySbCustomerServiceTitle, LazySbDesigner, LazySbDisclaimer, LazySbDiscountBadge, LazySbDiscountsGridItem, LazySbDiscountsGrid, LazySbDiscounts, LazySbDropdownContent, LazySbDropdown, LazySbFlockler, LazySbFooterCta, LazySbFooterForm, LazySbFreshworksButton, LazySbHeader, LazySbHeading, LazySbHeroVideo, LazySbHome, LazySbIframe, LazySbImage, LazySbInfoItem, LazySbInfo, LazySbInner, LazySbLanguages, LazySbLiftBig, LazySbLiftNormal, LazySbLinkMenu, LazySbLink, LazySbListingAd, LazySbMagazineCard, LazySbMagazine, LazySbMagazines, LazySbNosto, LazySbOpenJobs, LazySbPageCustomerService, LazySbPage, LazySbPopupMemberCollection, LazySbPopup, LazySbProductHighlightInfo, LazySbProductHighlightSquare, LazySbProductHighlight, LazySbProductHighlights, LazySbProductImageLiftMarker, LazySbProductImageLift, LazySbProductImageLifts, LazySbProductImageTextLift, LazySbProductSafetyContainer, LazySbProductSafety, LazySbPromotionCountdown, LazySbRichText, LazySbServiceForm, LazySbSocialLink, LazySbSocial, LazySbSwiperButton, LazySbSwiperNarrow, LazySbSwiperWide, LazySbSwiper, LazySbTable, LazySbTerms, LazySbTextColumn, LazySbTextColumns, LazySbTitle, LazySbTypeform, LazySbVideo, LazyCookieFirstPolicy, LazyCookieFirstTable } from '#components'
const lazyGlobalComponents = [
  ["SbArticleCardBig", LazySbArticleCardBig],
["SbArticleCardSmall", LazySbArticleCardSmall],
["SbArticleCard", LazySbArticleCard],
["SbArticleContent", LazySbArticleContent],
["SbArticleFeedLite", LazySbArticleFeedLite],
["SbArticleFeed", LazySbArticleFeed],
["SbArticleGallery", LazySbArticleGallery],
["SbArticleNav", LazySbArticleNav],
["SbArticleNew", LazySbArticleNew],
["SbArticleRecommendations", LazySbArticleRecommendations],
["SbArticleRecommended", LazySbArticleRecommended],
["SbArticle", LazySbArticle],
["SbArticlesFeedPages", LazySbArticlesFeedPages],
["SbArticlesLander", LazySbArticlesLander],
["SbArticlesPinned", LazySbArticlesPinned],
["SbArticles", LazySbArticles],
["SbBackground", LazySbBackground],
["SbBrandCardBig", LazySbBrandCardBig],
["SbBrandCard", LazySbBrandCard],
["SbBrand", LazySbBrand],
["SbBrandsGridBrand", LazySbBrandsGridBrand],
["SbBrandsGrid", LazySbBrandsGrid],
["SbBrandsLander", LazySbBrandsLander],
["SbBrandsListingBig", LazySbBrandsListingBig],
["SbBrandsListing", LazySbBrandsListing],
["SbCampaignSlide", LazySbCampaignSlide],
["SbCampaignSlides", LazySbCampaignSlides],
["SbCatalog", LazySbCatalog],
["SbCategoriesLander", LazySbCategoriesLander],
["SbCategoriesListingBig", LazySbCategoriesListingBig],
["SbCategoriesListing", LazySbCategoriesListing],
["SbCategoryCardBig", LazySbCategoryCardBig],
["SbCategoryCard", LazySbCategoryCard],
["SbCategoryCta", LazySbCategoryCta],
["SbCategoryLander", LazySbCategoryLander],
["SbCategoryMenu", LazySbCategoryMenu],
["SbClubLander", LazySbClubLander],
["SbContentButton", LazySbContentButton],
["SbContentForm", LazySbContentForm],
["SbContentImage", LazySbContentImage],
["SbCtaBig", LazySbCtaBig],
["SbCtaButton", LazySbCtaButton],
["SbCtaCampaignHeroBox", LazySbCtaCampaignHeroBox],
["SbCtaCampaignHero", LazySbCtaCampaignHero],
["SbCtaContent", LazySbCtaContent],
["SbCtaCountdown", LazySbCtaCountdown],
["SbCtaDiscount", LazySbCtaDiscount],
["SbCtaImage", LazySbCtaImage],
["SbCtaNarrow", LazySbCtaNarrow],
["SbCtaSimpleWithDiscount", LazySbCtaSimpleWithDiscount],
["SbCta", LazySbCta],
["SbCustomerServiceContent", LazySbCustomerServiceContent],
["SbCustomerServiceInner", LazySbCustomerServiceInner],
["SbCustomerServiceTitle", LazySbCustomerServiceTitle],
["SbDesigner", LazySbDesigner],
["SbDisclaimer", LazySbDisclaimer],
["SbDiscountBadge", LazySbDiscountBadge],
["SbDiscountsGridItem", LazySbDiscountsGridItem],
["SbDiscountsGrid", LazySbDiscountsGrid],
["SbDiscounts", LazySbDiscounts],
["SbDropdownContent", LazySbDropdownContent],
["SbDropdown", LazySbDropdown],
["SbFlockler", LazySbFlockler],
["SbFooterCta", LazySbFooterCta],
["SbFooterForm", LazySbFooterForm],
["SbFreshworksButton", LazySbFreshworksButton],
["SbHeader", LazySbHeader],
["SbHeading", LazySbHeading],
["SbHeroVideo", LazySbHeroVideo],
["SbHome", LazySbHome],
["SbIframe", LazySbIframe],
["SbImage", LazySbImage],
["SbInfoItem", LazySbInfoItem],
["SbInfo", LazySbInfo],
["SbInner", LazySbInner],
["SbLanguages", LazySbLanguages],
["SbLiftBig", LazySbLiftBig],
["SbLiftNormal", LazySbLiftNormal],
["SbLinkMenu", LazySbLinkMenu],
["SbLink", LazySbLink],
["SbListingAd", LazySbListingAd],
["SbMagazineCard", LazySbMagazineCard],
["SbMagazine", LazySbMagazine],
["SbMagazines", LazySbMagazines],
["SbNosto", LazySbNosto],
["SbOpenJobs", LazySbOpenJobs],
["SbPageCustomerService", LazySbPageCustomerService],
["SbPage", LazySbPage],
["SbPopupMemberCollection", LazySbPopupMemberCollection],
["SbPopup", LazySbPopup],
["SbProductHighlightInfo", LazySbProductHighlightInfo],
["SbProductHighlightSquare", LazySbProductHighlightSquare],
["SbProductHighlight", LazySbProductHighlight],
["SbProductHighlights", LazySbProductHighlights],
["SbProductImageLiftMarker", LazySbProductImageLiftMarker],
["SbProductImageLift", LazySbProductImageLift],
["SbProductImageLifts", LazySbProductImageLifts],
["SbProductImageTextLift", LazySbProductImageTextLift],
["SbProductSafetyContainer", LazySbProductSafetyContainer],
["SbProductSafety", LazySbProductSafety],
["SbPromotionCountdown", LazySbPromotionCountdown],
["SbRichText", LazySbRichText],
["SbServiceForm", LazySbServiceForm],
["SbSocialLink", LazySbSocialLink],
["SbSocial", LazySbSocial],
["SbSwiperButton", LazySbSwiperButton],
["SbSwiperNarrow", LazySbSwiperNarrow],
["SbSwiperWide", LazySbSwiperWide],
["SbSwiper", LazySbSwiper],
["SbTable", LazySbTable],
["SbTerms", LazySbTerms],
["SbTextColumn", LazySbTextColumn],
["SbTextColumns", LazySbTextColumns],
["SbTitle", LazySbTitle],
["SbTypeform", LazySbTypeform],
["SbVideo", LazySbVideo],
["CookieFirstPolicy", LazyCookieFirstPolicy],
["CookieFirstTable", LazyCookieFirstTable],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
